import React from 'react';

export default function BlogStatsBlock({ data }) {
  const { stats = [] } = data;

  return (
    <div className="blog-stats-grid">
      {stats.map((stat, i) => (
        <div key={i} className="blog-stat-item">
          <span className="blog-stat-number">{stat.number}</span>
          <span className="blog-stat-label">{stat.label}</span>
        </div>
      ))}
    </div>
  );
}
